import React from 'react';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { useMatch, useResolvedPath } from 'react-router';
import { SettingsNavItem } from './SettingsNav';

function RenderIfCurrent(props: { url: string; children?: React.ReactNode }) {
    // `end: false` keeps the tab marked current while a deeper sub-route of it is open.
    const isActive = useMatch({ path: useResolvedPath(props.url).pathname, end: false });
    if (isActive) return <>{props.children}</>;
    return null;
}

export default class SettingsNavDropDown extends React.Component<{
    navItems: SettingsNavItem[];
    sectionName?: string;
}> {
    render() {
        const { navItems, sectionName } = this.props;
        // The current-tab check needs hooks (useResolvedPath / useMatch), which a class cannot call, so
        // each item's check lives in RenderIfCurrent, rendered once per item.
        const currentNav = navItems.map((n) => (
            <RenderIfCurrent key={n.url} url={n.url}>
                {n.title}
            </RenderIfCurrent>
        ));

        return (
            <UncontrolledDropdown>
                <DropdownToggle caret color="secondary">
                    {sectionName || 'Settings'} &rsaquo; {currentNav}
                </DropdownToggle>
                <DropdownMenu strategy="fixed" className="settingsNavDropdownMenu">
                    {navItems.map((nav) => (
                        <DropdownItem tag={RouterNavLink} key={nav.url} to={nav.url}>
                            {nav.title}
                        </DropdownItem>
                    ))}
                </DropdownMenu>
            </UncontrolledDropdown>
        );
    }
}
